module.exports = __webpack_public_path__ + "img/logo.62f836c9.png";